import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FavouriteProductListConfigService } from '../../services/favourite-product-list-config/favourite-product-list-config.service';
import { ProductListComponent } from '../product-list/product-list.component';

@Component({
    selector: 'lib-favourite-product-list',
    templateUrl: './favourite-product-list.component.html',
    styleUrls: ['./favourite-product-list.component.css'],
    standalone: false
})
export class FavouriteProductListComponent implements OnInit {
  public favouriteProductListConfig = inject(FavouriteProductListConfigService);
  protected route = inject(ActivatedRoute);
  ngOnInit() {}
}
